module.exports = __webpack_public_path__ + "img/logo.0fa79066.jpg";